import { useTranslation as useI18nTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../i18n';

export const useTranslation = () => {
  const { t, i18n } = useI18nTranslation();
  const raw = i18n.language || i18n.resolvedLanguage || '';
  const base = (raw || 'en').split('-')[0];
  const currentLanguage = (SUPPORTED_LANGUAGES.includes(base as 'en' | 'fa' | 'ar') ? base : 'en') as 'en' | 'fa' | 'ar';

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return {
    t,
    changeLanguage,
    currentLanguage,
    supportedLanguages: SUPPORTED_LANGUAGES,
    isRTL: currentLanguage !== 'en'
  };
};

export default useTranslation;
